import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import { showErrors, showNotification } from '@/utils/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppCheckbox from '@/components/AppCheckbox.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import AppTextarea from '@/components/AppTextarea.vue';
import ListPage from '@/mixins/list-page';
import { MembersOrderBy } from '@/interfaces/member';
import { exportMembersList, findMembers } from './gql';
import MemberDialog from './script-dialog';
import { SnackType } from '@/interfaces/snack';
import { downloadBase64 } from '@/helpers/base64-to-file';

var MemberList = /*#__PURE__*/function (_mixins) {
  _inherits(MemberList, _mixins);

  var _super = _createSuper(MemberList);

  function MemberList() {
    var _this;

    _classCallCheck(this, MemberList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '会员管理'
    }, {
      text: '会员'
    }];
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.filter = {
      nickname: '',
      uniqueId: ''
    };
    _this.totalNum = 0;
    _this.loading = false;
    _this.disableConfirm = false;
    _this.headers = [{
      text: 'ID',
      value: 'id'
    }, {
      text: '头像',
      value: 'profilePhtoto'
    }, {
      text: '昵称',
      value: 'nickname'
    }, {
      text: '识别 ID',
      value: 'uniqueId'
    }, {
      text: '创建时间',
      value: 'createdAt'
    }, {
      text: '更新时间',
      value: 'updatedAt'
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.disabledActions = true;
    _this.members = [];
    _this.selectedMembers = [];
    return _this;
  }

  _createClass(MemberList, [{
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getMembers();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.onResize();
      this.restorePage(this.cache);
      this.getMembers();
    }
  }, {
    key: "refreshList",
    value: function () {
      var _refreshList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.clearFilter();
                this.getMembers();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshList() {
        return _refreshList.apply(this, arguments);
      }

      return refreshList;
    }()
  }, {
    key: "getMembers",
    value: function () {
      var _getMembers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, nickname, uniqueId, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, nickname = _this$filter.nickname, uniqueId = _this$filter.uniqueId;
                by = MembersOrderBy[sortBy[0] || 'realname'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  nickname: nickname || null,
                  uniqueId: uniqueId || null
                };
                _context2.next = 10;
                return this.queryMembersRequest(order, paging, where);

              case 10:
                result = _context2.sent;

                if (result) {
                  this.members = result.members;
                  this.totalNum = result.paging.totalCount;
                }

                this.loading = false;
                this.storePage();

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMembers() {
        return _getMembers.apply(this, arguments);
      }

      return getMembers;
    }()
  }, {
    key: "queryMembersRequest",
    value: function () {
      var _queryMembersRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findMembers,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.findMembers);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function queryMembersRequest(_x, _x2, _x3) {
        return _queryMembersRequest.apply(this, arguments);
      }

      return queryMembersRequest;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function () {
      var _filterQuerySubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getMembers();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function filterQuerySubmit() {
        return _filterQuerySubmit.apply(this, arguments);
      }

      return filterQuerySubmit;
    }()
  }, {
    key: "deleteConfirm",
    value: function () {
      var _deleteConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var $R, members, targetMember, index;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                $R = this.$R, members = this.members, targetMember = this.targetMember;
                _context5.next = 3;
                return this.deleteRequest();

              case 3:
                index = $R.findIndex(function (member) {
                  return member.id === (targetMember !== null && targetMember !== void 0 ? targetMember : {}).id;
                })(members);

                if (index !== -1) {
                  this.members = $R.remove(index, 1)(members);
                }

                this.totalNum -= 1;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteConfirm() {
        return _deleteConfirm.apply(this, arguments);
      }

      return deleteConfirm;
    }()
  }, {
    key: "routeToDetail",
    value: function routeToDetail(item) {
      this.$router.push({
        name: 'MemberDetail',
        params: {
          id: item.id + ''
        }
      });
    }
  }, {
    key: "clearFilter",
    value: function clearFilter() {
      this.filter = {
        nickname: '',
        uniqueId: ''
      };
    }
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this$options2, sortBy, sortDesc, _this$filter2, nickname, uniqueId, by, asc, order, where, result, _result$data$exportMe, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, nickname = _this$filter2.nickname, uniqueId = _this$filter2.uniqueId;
                by = MembersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  nickname: nickname || null,
                  uniqueId: uniqueId || null
                };
                _context6.prev = 8;
                _context6.next = 11;
                return this.$apollo.query({
                  query: exportMembersList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context6.sent;

                if (result.data) {
                  _result$data$exportMe = result.data.exportMembersList, fileName = _result$data$exportMe.fileName, contentB64 = _result$data$exportMe.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context6.next = 20;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](8);
                typedError = _context6.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }]);

  return MemberList;
}(mixins(MemberDialog, ListPage));

__decorate([State(function (state) {
  return state.page.MemberList;
})], MemberList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], MemberList.prototype, "onOptionsChanged", null);

MemberList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppCheckbox: AppCheckbox,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppDatePicker: AppDatePicker,
    AppSearchBtn: AppSearchBtn,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppTextarea: AppTextarea
  }
})], MemberList);
export default MemberList;